"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useImageLoader(src, onError) {
    var _a = (0, react_1.useState)({
        imgData: null,
        error: false,
        naturalWidth: 0,
        naturalHeight: 0,
    }), state = _a[0], setState = _a[1];
    (0, react_1.useEffect)(function () {
        setState({ imgData: null, error: false, naturalWidth: 0, naturalHeight: 0 });
        if (!src) {
            setState(function (prev) { return (__assign(__assign({}, prev), { error: true })); });
            return;
        }
        var img = new Image();
        var handleLoad = function () {
            setState({
                imgData: img.src,
                error: false,
                naturalWidth: img.naturalWidth,
                naturalHeight: img.naturalHeight,
            });
        };
        var handleError = function (error) {
            setState(function (prev) { return (__assign(__assign({}, prev), { error: true })); });
            onError === null || onError === void 0 ? void 0 : onError(error);
        };
        img.addEventListener("load", handleLoad);
        img.addEventListener("error", handleError);
        img.src = src;
        return function () {
            img.removeEventListener("load", handleLoad);
            img.removeEventListener("error", handleError);
        };
    }, [src, onError]);
    return state;
}
exports.default = useImageLoader;
